module.exports = __webpack_public_path__ + "img/luna gibosa creciente.77e6f271.png";